import { select } from "@single-js/common/util/query";
import { differenceInSeconds } from "date-fns";
import { from, merge, of } from "rxjs";
import { logError } from "util/logging";
import { makeActionCreator } from "worker/api/helpers";
// We default this limit to 1028 which is the maximum size of the events'
// circular buffer in MemSQL. We are just being careful in case that
// size ever increases.
const SQL_EVENTS_QUERY = (limit = 1028) => `
    SELECT
        EVENT_TIME AS eventTime,
        SEVERITY AS eventSeverity,
        EVENT_TYPE AS eventType,
        DETAILS AS eventDetails
    FROM
        INFORMATION_SCHEMA.LMV_EVENTS
    ORDER BY
        EVENT_TIME DESC
    LIMIT
        ${limit}
`;
const getEventSeverity = (eventSeverity) => {
    switch (eventSeverity) {
        case "NOTICE":
        case "WARNING":
        case "ERROR":
            return eventSeverity;
        default:
            return "UNKNOWN";
    }
};
const createEventsAction = (rawEvents, startDate) => {
    const events = [];
    for (let i = 0; i < rawEvents.length; i++) {
        const rawEvent = rawEvents[i];
        let eventDetails;
        try {
            eventDetails = JSON.parse(rawEvent.eventDetails);
        }
        catch (e) {
            return {
                type: "EVENTS",
                error: true,
                payload: {
                    message: e.message,
                },
            };
        }
        events.push({
            eventTime: rawEvent.eventTime,
            eventSeverity: getEventSeverity(rawEvent.eventSeverity),
            eventType: rawEvent.eventType,
            eventDetails,
        });
    }
    return {
        type: "EVENTS",
        payload: {
            loading: false,
            data: {
                events,
                deltaTimeS: differenceInSeconds(new Date(), startDate),
            },
        },
        error: false,
    };
};
export const queryEvents = makeActionCreator({
    name: "queryEvents",
    handle: (ctx, { limit }) => {
        const $loading = of({
            type: "EVENTS",
            error: false,
            payload: { loading: true },
        });
        const startDate = new Date();
        const $compute = from(ctx.manager
            .getPooledConnection()
            .then((conn) => select(conn, SQL_EVENTS_QUERY(limit))
            .then((events) => createEventsAction(events, startDate))
            .catch((err) => {
            logError(err);
            return {
                type: "EVENTS",
                error: true,
                payload: {
                    message: err.message,
                },
            };
        })
            .finally(() => conn.release()))
            .catch((err) => {
            return {
                type: "EVENTS",
                error: true,
                payload: {
                    message: err.message,
                },
            };
        }));
        return merge($loading, $compute);
    },
});
